<template>
    <div v-if="isInTimeframe" class="bottom-20 top-15">
        <router-link v-if="showLink" to="/video-conferences" class="secondary start-telehealth">
            Start this Telehealth Appointment
        </router-link>
        <button
            v-else-if="placeOfService === '12'"
            type="button"
            @click="openMeetingLink"
            class="fw-600 secondary start-telehealth w-20"
        >
            Join Meeting
        </button>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import dayjs from '@/util/dayjs';

    export default {
        name: 'TelehealthLink',
        computed: {
            ...mapState('eventEditor', {
                startTime: (state) => state.event.dayt_appt_start,
                endTime: (state) => state.event.dayt_appt_end,
                showLink: (state) => !!state.event.telehealth || state.event.location === 2,
                placeOfService: (state) => state.event.place_of_service_code,
                meetingLink: (state) => state.event.meeting_link,
                isInTimeframe() {
                    const earliest = dayjs(this.startTime).add(-15, 'minute');
                    const latest = dayjs(this.endTime).add(60, 'minute');

                    const now = dayjs();
                    return now.isBetween(earliest, latest);
                },
            }),
        },
        methods: {
            openMeetingLink() {
                window.open(this.meetingLink, '_blank');
            },
        },
    };
</script>
